package com.patronat.top.features.auth.data.network

import com.patronat.top.core.domain.usecase.command.auth.*
import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.AuthActionResponse
import com.patronat.top.dto.AuthResponse
import com.patronat.top.dto.AuthSuccessResponse
import com.patronat.top.features.auth.data.mappers.toRequest
import io.ktor.client.HttpClient
import io.ktor.client.request.post
import io.ktor.client.request.setBody

class AuthRemoteDataSource(
    private val httpClient: HttpClient
)  {

    suspend fun startRegistration(command: RegistrationUserCommand): NetworkResult<AuthResponse> {
        val request = command.toRequest()
        return safeApiCall {
            httpClient.post("auth/register") { setBody(request) }
        }
    }

    suspend fun startLogin(command: LoginCommand): NetworkResult<AuthResponse> {
        val request = command.toRequest()
        return safeApiCall {
            httpClient.post("auth/login") { setBody(request) }
        }
    }

    suspend fun confirmPhone(command: ConfirmPhoneCommand): NetworkResult<AuthResponse> {
        val request = command.toRequest()
        return safeApiCall {
            httpClient.post("auth/confirm/phone") { setBody(request) }
        }
    }

    suspend fun confirmEmail(command: ConfirmEmailCommand): NetworkResult<AuthResponse> {
        val request = command.toRequest()
        return safeApiCall {
            httpClient.post("auth/confirm/email") { setBody(request) }
        }
    }

    suspend fun resendPhoneCode(command: SendCodeToPhoneCommand): NetworkResult<AuthActionResponse> {
        val request = command.toRequest()
        return safeApiCall {
            httpClient.post("auth/resend/phone") { setBody(request) }
        }
    }

    suspend fun resendEmailCode(command: SendCodeToEmailCommand): NetworkResult<AuthActionResponse> {
        val request = command.toRequest()
        return safeApiCall {
            httpClient.post("auth/resend/email") { setBody(request) }
        }
    }

}
